// 1. 외부 패키지
import { useRecoilValue } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import Skeleton from "../skeleton";
import media_atom from "../../atom/media-atom";

// 4. 타입

const TableSkeleton = () => {

	const media = useRecoilValue(media_atom);

	return (
		<Skeleton width={'100%'} height={110} marginBottom={media === "M" ? 20 : 40} className="table-skeleton" />
	);
};

export default TableSkeleton;